import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rodental_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "A apărut o eroare. Vă rugăm încercați din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e?.msg || JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const CLINIC = {
  name: "Ro-Dental Cluj-Napoca",
  fullName: "CMI. Dr. Biriș Cornelia",
  legalName: "CMI. Dr. Biriș Cornelia",
  siteName: "Ro-Dental Cluj-Napoca",
  cabinetName: "CMI. Dr. Biriș Cornelia",
  doctor: "Dr. Cornelia Maria Biriș",
  doctorTitle: "Medic Primar Stomatolog",
  slogan: "Zâmbetul tău, pasiunea mea!",
  address: "Str. General Eremia Grigorescu Nr. 81, Cluj-Napoca",
  phone: "0721592343",
  phonePretty: "0721 592 343",
  phoneTel: "tel:+40721592343",
  email: "nelibiris452@gmail.com",
  emailBookings: "nelibiris452@gmail.com",
  experience: "25+ ani de experiență",
  motto: "Educația și prevenția merg mână în mână cu încrederea în sine!",
  googleReviewUrl: "https://search.google.com/local/writereview?placeid=ChIJM2KBfIQOSUcRJK_KwI0fqSY",
  googleMapsUrl: "https://www.google.com/maps/search/?api=1&query=Cabinet+Stomatologic+Ro-Dental+Cluj-Napoca",
  mapsEmbed: "https://www.google.com/maps?q=Str.+General+Eremia+Grigorescu+81,+Cluj-Napoca&output=embed",
};

export const ASSETS = {
  // Sigla oficială — mascota Ro-Dental Cluj-Napoca (perechea dansatoare pe fundal cremă)
  emblem: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/j6iqnhhw_IMG-20260630-WA0007.jpg",
  officialLogo: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/j6iqnhhw_IMG-20260630-WA0007.jpg",
  // Portret oficial HERO — Dr. Biriș Cornelia Maria în cabinetul în care își desfășoară activitatea (Cluj-Napoca)
  heroPortrait: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/uo5u6zxo_file_000000000e0481f488112bcade61409e.png",
  // Poster oficial RO-DENTAL CLINIC — cartea de vizită completă cu Dr. Biriș + servicii + date contact (sept. 2026)
  businessCard: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/giihmydl_file_0000000008a88210a9f8993e8e51f2dc.png",
  // Portret nou Dr. Biriș Cornelia — halat colorat, zâmbind în noul cabinet (sept. 2026)
  poster: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/3ypcpqu4_file_00000000dc888246a42c794611a352fc.png",
  cabinetNoMask: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/3ypcpqu4_file_00000000dc888246a42c794611a352fc.png",
  // Interior nou cabinet — scaun stomatologic turcoaz, echipament modern (sept. 2026)
  cabinetComposition: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/la0gm2jq_IMG_20260904_105522.webp",
  // Portret întreg Dr. Biriș așezat în cabinet (sept. 2026) — folosit pe pagina „Prima consultație"
  drSeatedPortrait: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/e6l4en7a_file_00000000c3ac82438ce1b958f8e441ac.png",
  // Prim-plan cald Dr. Biriș în noul cabinet (sept. 2026) — folosit pe pagina „Despre"
  drWarmCloseup: "https://customer-assets-m6fa6gv7.emergentagent.net/job_ro-dental-clinic/artifacts/yqgz1bp0_file_00000000290c8246a4c524a204a635af.jpg",
  // Voluntariat
  volunteerPoster: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/lutlfbn0_file_000000004f747243ae3670033e96039c.png",
  volunteerWorkshop: "https://customer-assets.emergentagent.com/job_ro-dental-clinic/artifacts/4yj8ninn_file_000000005ff0722f95c9352616e8cb72.png",
};
